import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
// No social icons needed
// Logo removed - using text instead

const FooterContainer = styled.footer`
  background-color: ${props => props.theme.colors.secondary};
  color: ${props => props.theme.colors.white};
  padding: 4rem 0 2rem;
`;

const FooterContent = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
`;

const FooterLogo = styled.div`
  margin-bottom: 1.5rem;
  
  img {
    height: 40px;
    margin-bottom: 1rem;
  }
  
  p {
    color: ${props => props.theme.colors.lightGray};
    font-size: 0.9rem;
  }
`;

const FooterLinksContainer = styled.div`
  h3 {
    color: ${props => props.theme.colors.white};
    font-size: 1.2rem;
    margin-bottom: 1.5rem;
  }
`;

const FooterLinks = styled.ul`
  list-style: none;
`;

const FooterLinkItem = styled.li`
  margin-bottom: 0.8rem;
  
  a {
    color: ${props => props.theme.colors.lightGray};
    transition: ${props => props.theme.transition};
    
    &:hover {
      color: ${props => props.theme.colors.primary};
    }
  }
`;

// Social links removed

const Copyright = styled.div`
  text-align: center;
  margin-top: 3rem;
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  color: ${props => props.theme.colors.lightGray};
  font-size: 0.9rem;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 2rem;
  padding-right: 2rem;
`;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <FooterContent>
        <FooterLogo>
          <h2 style={{
            fontSize: '1.8rem',
            fontWeight: '700',
            marginBottom: '1rem',
            color: '#ffffff'
          }}>RDT Chain</h2>
          <p>
            RDT Chain is a fast, secure, and scalable blockchain designed to enable
            cross-border payments with zero transaction fees.
          </p>
          {/* Social links removed */}
        </FooterLogo>

        <FooterLinksContainer>
          <h3>Quick Links</h3>
          <FooterLinks>
            <FooterLinkItem>
              <Link to="/">Home</Link>
            </FooterLinkItem>
            <FooterLinkItem>
              <Link to="/about">About</Link>
            </FooterLinkItem>
            <FooterLinkItem>
              <Link to="/ecosystem">Ecosystem</Link>
            </FooterLinkItem>
          </FooterLinks>
        </FooterLinksContainer>

        <FooterLinksContainer>
          <h3>Resources</h3>
          <FooterLinks>
            <FooterLinkItem>
              <Link to="/developers">Developers</Link>
            </FooterLinkItem>
            <FooterLinkItem>
              <Link to="/wallet">Wallet</Link>
            </FooterLinkItem>
            <FooterLinkItem>
              <a href="https://explorer.rdtchain.com" target="_blank" rel="noopener noreferrer">
                Explorer
              </a>
            </FooterLinkItem>
          </FooterLinks>
        </FooterLinksContainer>

        <FooterLinksContainer>
          <h3>Contact</h3>
          <FooterLinks>
            <FooterLinkItem>
              <Link to="/contact">Contact Us</Link>
            </FooterLinkItem>
            <FooterLinkItem>
              <a href="mailto:support@rdtchain.com">support@rdtchain.com</a>
            </FooterLinkItem>
            <FooterLinkItem>
              <a href="https://rdtchain.com/whitepaper.pdf" target="_blank" rel="noopener noreferrer">
                Whitepaper
              </a>
            </FooterLinkItem>
          </FooterLinks>
        </FooterLinksContainer>
      </FooterContent>
      <Copyright>

        <div className="mt-4 flex justify-center" style={{ marginTop: '1rem', display: 'flex', justifyContent: 'center', marginBottom: '2rem' }}>
          <button
            onClick={async () => {
              if (typeof window === 'undefined' || !window.ethereum) {
                alert('MetaMask is not available.');
                return;
              }
              try {
                await window.ethereum.request({
                  method: 'wallet_addEthereumChain',
                  params: [
                    {
                      chainId: '0x' + (Number(875423)).toString(16),
                      chainName: 'RDT Chain',
                      rpcUrls: ["https://rpc-supernova.rdtchain.com"],
                      nativeCurrency: {
                        name: "RDT",
                        symbol: "RDT",
                        decimals: 18,
                      },
                      blockExplorerUrls: ["https://explorer.rdtchain.com"],
                    },
                  ],
                });
              } catch (err) {
                if (err.code !== 4001) alert('Could not add to MetaMask: ' + err.message);
              }
            }}
            className="flex items-center gap-2 px-4 py-2 rounded-lg bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-semibold shadow transition-colors text-sm"
            type="button"
            style={{
              backgroundColor: '#F6E7D0',
              color: '#000000',
              border: 'none',
              cursor: 'pointer',
              alignItems: 'center',
              padding: '10px 20px',
              borderRadius: '5px',
              fontSize: '16px',
              fontWeight: 'bold',
            }}
          >
            <svg width="20" height="20" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg"><g><polygon fill="#E2761B" points="36.6,1.1 21,11.1 23.8,5.1 " /><polygon fill="#E4761B" points="1.4,1.1 14.2,11.2 13.6,5.1 " /><polygon fill="#D7C1B3" points="30.6,27.7 26.1,34.4 35.5,37.1 38,27.9 " /><polygon fill="#D7C1B3" points="0,27.9 2.5,37.1 11.9,34.4 7.4,27.7 " /><polygon fill="#EA8D3A" points="10.7,16.8 8.1,21.1 18.2,21.6 17.8,10.1 " /><polygon fill="#EA8D3A" points="27.3,16.8 20.2,10.1 19.9,21.6 29.9,21.1 " /><polygon fill="#F6E7D0" points="11.9,34.4 17.7,31.6 12.7,27.7 " /><polygon fill="#F6E7D0" points="26.1,34.4 25.3,27.7 20.2,31.6 " /><polygon fill="#D7C1B3" points="20.2,31.6 25.3,27.7 24.9,24.3 13.1,24.3 12.7,27.7 17.7,31.6 " /><polygon fill="#E4761B" points="11.9,34.4 12.7,27.7 7.4,27.7 " /><polygon fill="#E4761B" points="25.3,27.7 26.1,34.4 30.6,27.7 " /><polygon fill="#D7C1B3" points="30.6,27.7 24.9,24.3 29.9,21.1 " /><polygon fill="#D7C1B3" points="7.4,27.7 13.1,24.3 8.1,21.1 " /><polygon fill="#F6E7D0" points="29.9,21.1 24.9,24.3 25.3,27.7 30.6,27.7 " /><polygon fill="#F6E7D0" points="7.4,27.7 12.7,27.7 13.1,24.3 7.4,27.7 " /><polygon fill="#F6E7D0" points="13.1,24.3 12.7,27.7 17.7,31.6 20.2,31.6 25.3,27.7 24.9,24.3 13.1,24.3 " /></g></svg>
            Add to MetaMask
          </button>
        </div>
        <p className='mt-5'>&copy; {currentYear} RDT Chain Consortium. All rights reserved.</p>
      </Copyright>
    </FooterContainer>
  );
};

export default Footer;